import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/linkedin-in': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M100.3 448h-92.9v-299.1h92.9v299.1zM53.8 108.1c-29.7 0-53.8-24.6-53.8-54.3 0-29.7 24.1-53.8 53.8-53.8s53.8 24.1 53.8 53.8c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7v-145.6c0-34.7-0.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7v148.1h-92.8v-299.1h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3v164.3h-0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linkedin-in.js
// module id = 915
// module chunks = 0